export enum ConnectionPlacementType {
    CONNECTION_HUB,
    OVERLAY_LIST,
}